import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 992;

const subscribe = (onChange: () => void) => {
  window.addEventListener('resize', onChange);

  return () => window.removeEventListener('resize', onChange);
};

const useIsMobile = () => {
  return useSyncExternalStore(
    subscribe,
    () => window.innerWidth < MOBILE_BREAKPOINT,
    () => null
  );
};

export default useIsMobile;
